<template>
  <IconField>
    <InputIcon>
      <AppIcon name="regular-magnifying-glass" />
    </InputIcon>
    <InputText
      ref="input"
      v-bind="$attrs"
      class="rounded-full transition-[width,max-width] duration-200 ease-in-out"
      type="text"
      :model-value="modelValue"
      :placeholder="placeholder"
      size="small"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <!-- design-lint-allow primevue-global: the trailing icon slot of IconField, like the magnifier above -->
    <InputIcon v-if="clearable && modelValue">
      <AppButton
        variant="text"
        rounded
        severity="secondary"
        size="small"
        class="-my-1 size-6"
        :aria-label="$t('form.actions.clear')"
        @click="clear"
      >
        <template #icon>
          <AppIcon
            name="regular-xmark"
            size="sm"
          />
        </template>
      </AppButton>
    </InputIcon>
    <slot />
  </IconField>
</template>

<script>
export default { inheritAttrs: false };
</script>

<script setup>
// The one search field: pill-shaped, magnifying glass on the left (see design_system/components/
// AppSearch.vue). Width classes go straight onto the input, so callers style it as before, and a
// fixed-width caller can add a `focus:` width to make it grow. `clearable` adds a clear button once
// there is a query. The slot takes a trailing InputIcon.
// For typeahead suggestions use SearchAutoComplete.vue instead.
import { ref } from 'vue';
import AppButton from '@/app/shared_components/AppButton.vue';

defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, required: true },
  clearable: { type: Boolean },
});

const emit = defineEmits(['update:modelValue']);

const input = ref(null);

function focus() {
  if (input.value) input.value.$el.focus();
}

function clear() {
  emit('update:modelValue', '');
  focus();
}

defineExpose({ focus });
</script>
